module.exports = __webpack_public_path__ + "media/images/video/cyclebar-app-promo-73dcd77532cc396e1f5475a938621acb.png";